import { DeviceType } from '@/lib/types/tutorial';

export function getDeviceType(): DeviceType {
  if (typeof window === 'undefined') return 'desktop'; 
  
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'android', 
    'webos', 
    'iphone', 
    'ipad', 
    'ipod', 
    'blackberry', 
    'windows phone'
  ];
  
  const isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword));
  
  const isSmallScreen = window.innerWidth <= 768;
  
  return (isMobileUA || isSmallScreen) ? 'mobile' : 'desktop';
}